<template>
<div class="orderdetail_container" name="orderdetail">
  <topNav v-show="topShow" :title="title"></topNav>
  <div class="informinfo" v-for="(item,index) in payParams" :key="index">
    <div class="price">
      <div class="companyname">{{item.merchant}}</div>
      <div class="fee">-{{item.payAmount}}</div>
      <p>{{item.payState}}</p>
    </div>
    <div class="orderdetail">
      <p><span class="leftinfo">车牌号</span><span class="rightinfo">{{item.carNumber}}</span></p>
      <p><span class="leftinfo">停车场</span><span class="rightinfo">{{item.parkingName}}</span></p>
      <!-- <p><span class="leftinfo">停车时长</span><span class="rightinfo">{{item.totalTime}}</span></p> -->
      <p><span class="leftinfo">付款方式</span><span class="rightinfo">{{item.payChannelName}}</span></p>
    </div>
    <div class="orderinfo">
      <p class="creattime"><span class="leftinfo">缴费时间</span><span class="rightinfo">{{item.carInDate}}</span></p>
      <p class="orderno"><span class="leftinfo">订单号</span><span class="rightinfo">{{item.orderNo}}</span></p>
      <!-- <p class="businiessno"><span class="leftinfo">第三方订单号</span><span class="rightinfo">{{item.outOrderNo}}</span></p> -->
    </div>
    <!-- <div class="opertion">
      <van-cell-group>
        <van-cell title="联系商户" is-link @click="alertMsg"/>
        <van-cell title="申请退款" is-link @click="alertMsg" /> 
        <van-cell v-if="invoiceEnable" title="开具发票" is-link @click="getOpenInvoiceStatus" /> 
      </van-cell-group>
    </div> -->
  </div>

</div>

</template>
<script>
import topNav from "../topnav/topnav"
import { Cell, CellGroup } from 'vant'
import {DETAIL as API} from "@/assets/api"

export default {
  name: 'orderdetail',
  components:{
     topNav,
     [Cell.name]:Cell,
     [CellGroup.name]:CellGroup
  },
  data() {
    return {
      title:"支付详情",
      payParams:[],
      topShow:true,
      isLoading: false,
      invoiceEnable: false,
    }
  },
  created(){
    let merchant=this.commonUtil.getUrlKey("merchant");
    let carNumber=this.commonUtil.getUrlKey("carNumber");
    let parkingName=this.commonUtil.getUrlKey("parkingName");
    let payAmount=this.commonUtil.getUrlKey("payAmount");
    let totalTimeM=this.commonUtil.getUrlKey("totalTime");
    let payChannelName=this.commonUtil.getUrlKey("payChannelName");
    let carInDate=this.commonUtil.getUrlKey("carInDate");
    let orderNo=this.commonUtil.getUrlKey("orderNo");
    let outOrderNo=this.commonUtil.getUrlKey("outOrderNo");
    let payStates=this.commonUtil.getUrlKey("payState");
    let invoiceEnable = this.commonUtil.getUrlKey("invoiceEnable")
    
    if(typeof invoiceEnable == 'boolean'){
      this.invoiceEnable = invoiceEnable
    }
    if(typeof invoiceEnable == 'string'){
      if(invoiceEnable == "true"){
        this.invoiceEnable = true
      }else{
        this.invoiceEnable = false
      }
    }

    let totalTime = ''
    if (totalTimeM){
      if(totalTimeM.indexOf("分钟") != -1){
        totalTime = totalTimeM
      }else{
        var totalMinute = totalTimeM % 60,
            totalHours = Math.floor(totalTimeM / 60);
        totalTime = totalHours + "小时" + totalMinute + "分钟";
      }
    }
    
    var payState;

    // if(payStates==0){payState="未支付";
    // }else if(payStates==1){payState="支付成功";
    // }else ;
    payState = '支付成功'

    this.payParams.push({
      "merchant":merchant,//商户名称
      "carNumber":carNumber,//车牌号
      'payAmount':payAmount,//支付金额
      'parkingName':parkingName,//停车场
      'totalTime':totalTime,//停车总时长
      'payChannelName':payChannelName,//支付方式
      'carInDate':carInDate,//创建时间
      'orderNo':orderNo,//订单号
      'outOrderNo':outOrderNo,//第三方订单号
      'payState':payState,//支付状态
      'invoiceEnable': this.invoiceEnable
      })

  },
  beforeRouteEnter(to, from, next){
    if(to.name=='accountrecorder')
    {
        this.topShow=true
    }
    next();

  },
  methods:{
    alertMsg(){
        this.$dialog.alert({
          duration:1200,
          message: '敬请期待'
        });
    },
    getOpenInvoiceStatus(){
      if(this.isLoading) return
      this.isLoading = true

      if(!this.payParams.length){
        this.$dialog.alert('暂无订单信息')
        return
      }
      var req = {orderNum: this.payParams[0].orderNo}
      this.$http({
        method: 'get',
        url: API.GET_OPENINVOICE_STATUS,
        data: req,
        success: function(res){
            if (res.code == 0) {
              if(!res.flag){
                this.$router.push({name: 'invoice', query: this.payParams[0] })
              }else{
                this.$dialog.alert({
                  duration:1200,
                  message: '该订单已经开过发票了'
                });
              }
            } else {
              this.Toast(res.msg)
            }
            this.isLoading = false
        }.bind(this),
        error: function(error){
          alert("获取发票信息失败")
          this.isLoading = false
        }
      })
    },
  },

}
</script>
<style>
.price,.orderdetail{
  background: white;
}
.orderdetail{
  padding-bottom: 6px;
}
.orderinfo{
  background: white;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding-top: 6px;
}
.price{
  padding: 23px 0;
  font-size: 15px;
}
.fee{
  padding:8px 0;
  font-size: 27px;
  margin-top: 9px;
}
.informinfo p{
  width:92%;
  margin: 0 auto;
  padding:10px 0;
  font-size: 15px;
}
.informinfo .leftinfo{
  display:inline-block;
  width: 30%;
  text-align: left;
}
.informinfo .rightinfo{
  display:inline-block;
  width: 70%;
  text-align: right;
}
.opertion{
  margin-top: 10px;
  border-top: 1px solid #f5f5f5;
}
.van-cell__title{
  text-align: left;
}
</style>
<style scoped>
  .orderdetail_container{
    min-height: 100vh;
    background-color: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/components/paydetail/informdetail2.vue